// userInput needs to be saved to localStorage so that we can access it if the user gets redirected to another app
// eg. auth.spa and then comes back to PPF, eg. for this bug: https://jira.internal.babbel.com/browse/POP-2652
import React, { useState } from 'react';

import { UserInputType } from '../nodes/types.common';

const useUserInput = (
  initialValue: Partial<UserInputType>
): [Partial<UserInputType>, React.Dispatch<React.SetStateAction<Partial<UserInputType>>>] => {
  const [userInput, setUserInput] = useState(initialValue);

  const setUserInputWithLocalStorage = (updatedUserInput: React.SetStateAction<Partial<UserInputType>>): void => {
    // we need to remove the password so we don't store it to localStorage
    localStorage.setItem('userInput', JSON.stringify({ ...updatedUserInput, password: '' }));
    setUserInput(updatedUserInput);
  };

  return [userInput, setUserInputWithLocalStorage];
};

export default useUserInput;
